export default [{
  name: "Rubás Tünde",
  image: require('../images/szakaszisztens/image001.jpg')
},
{
  name: "Husztey Réka",
  image: require('../images/szakaszisztens/huszteireka.jpeg'),
},
{
  name: "Szekeres Eszter",
  image: require('../images/no-photo.png'),
},
{
  name: "Lévay Ágnes",
  image: require('../images/no-photo.png'),
}
]